import React from "react";
import styled from "@emotion/styled";

import { Avatar, Button, Typography } from "@mui/material";

import SignInComponent from "@/components/auth/SignIn";
import useAuth from '@/hooks/useAuth';
import { useNavigate } from "react-router-dom";
import { User } from "lucide-react";
import LogoComponent from "@/components/logos/Logo";

const BigAvatar = styled(Avatar)`
  width: 92px;
  height: 92px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
`;

function SignIn() {
  const { signIn, signInWithGoogle } = useAuth();
  const { user } = useAuth();
  const navigate = useNavigate();

  const login = async () => {
    try {
      await signInWithGoogle();
      console.log("User signed in successfully");
      window.location.href = '/';
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <React.Fragment>
      <div style={{textAlign: 'center', marginBottom: '20px'}}>
        <LogoComponent fill="#0f4c81" style={{width: "100px", margin: "0px auto"}} />
        <br />
        <br />
        <Typography component="h1" variant="h3" align="center" gutterBottom>
          Log in to your account
        </Typography>
        <Typography component="h2" variant="subtitle1" align="center">
          Welcome back! Please enter your details.
        </Typography>
        <br />
        <br />
        <br />
        <br />
        <Button variant="contained" onClick={login}>
          Sign in with Google
        </Button>
      </div>
      
    </React.Fragment>
  );
}

export default SignIn;
